import { createI18n } from 'vue-i18n'

// Locales are coming from an external .json files that we fetch

// Store the fetched locales globally
export let fetchedLocales: unknown = null

// TODO handle errors
export const fetchLocales = async () => {
  if (!window.db2Config?.localesPath) {
    throw new Error('Missing locales path')
  }
  const req = await fetch(window.db2Config?.localesPath, { method: 'GET' })
  const json = await req.json()
  fetchedLocales = json
  return json
}

export const createI18nConfig = () => {
  if (!fetchedLocales) {
    throw new Error('Missing locales: "fetchLocales" should be called first')
  }
  const messages = fetchedLocales
  const localeCode =
    window.galaxyInfo && window.galaxyInfo.local !== '' ? window.galaxyInfo.local : 'en'

  const i18n = createI18n({
    legacy: false, // you must set `false`, to use Composition API
    locale: localeCode, // TODO: xo7 check for dynamization => Antoine: Handle the local "speudo-dynamic way"
    fallbackLocale: 'en', // set fallback locale
    messages: {
      [localeCode]: messages,
      en: messages, // default case for fallback (not suppose to happen)
    },
  })
  return i18n
}
